import { useState } from 'react';
import { Link } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpLimitedEditionsPage() {
  const t = useTranslations('galleries_help.limited_editions');
  const [openSections, setOpenSections] = useState({
    requestLe: false,
    whatAreLe: false,
    potentialIncome: false,
    impactOriginal: false,
    pricesSizes: false,
    qualityControl: false,
    requirementsActivation: false,
    activateAfterUpload: false,
    withdrawingOriginals: false,
    paymentsReturnsRefunds: false,
    agreementSummary: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('requestLe')}
            aria-expanded={openSections.requestLe}
          >
            <h2>{t('sections.request_le.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.requestLe ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.requestLe && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.request_le.p1')}</p>
              <p>{t('sections.request_le.p2')}</p>
              <p>{t('sections.request_le.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('whatAreLe')}
            aria-expanded={openSections.whatAreLe}
          >
            <h2>{t('sections.what_are_le.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.whatAreLe ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whatAreLe && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.what_are_le.p1')}</p>
              <p>{t('sections.what_are_le.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('potentialIncome')}
            aria-expanded={openSections.potentialIncome}
          >
            <h2>{t('sections.potential_income.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.potentialIncome ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.potentialIncome && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.potential_income.p1')}</p>
              <p>{t('sections.potential_income.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('impactOriginal')}
            aria-expanded={openSections.impactOriginal}
          >
            <h2>{t('sections.impact_original.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.impactOriginal ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.impactOriginal && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.impact_original.p1')}</p>
              <p>{t('sections.impact_original.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('pricesSizes')}
            aria-expanded={openSections.pricesSizes}
          >
            <h2>{t('sections.prices_sizes.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.pricesSizes ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.pricesSizes && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.prices_sizes.p1')}</p>
              <p>{t('sections.prices_sizes.p2')}</p>
              <p>{t('sections.prices_sizes.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('qualityControl')}
            aria-expanded={openSections.qualityControl}
          >
            <h2>{t('sections.quality_control.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.qualityControl ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.qualityControl && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.quality_control.p1')}</p>
              <p>{t('sections.quality_control.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('requirementsActivation')}
            aria-expanded={openSections.requirementsActivation}
          >
            <h2>{t('sections.requirements_activation.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.requirementsActivation ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.requirementsActivation && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.requirements_activation.intro')}</p>
              <ul>
                <li>{t('sections.requirements_activation.list_1')}</li>
                <li>{t('sections.requirements_activation.list_2')}</li>
                <li>{t('sections.requirements_activation.list_3')}</li>
                <li>{t('sections.requirements_activation.list_4')}</li>
              </ul>
              <p>{t('sections.requirements_activation.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('activateAfterUpload')}
            aria-expanded={openSections.activateAfterUpload}
          >
            <h2>{t('sections.activate_after_upload.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.activateAfterUpload ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.activateAfterUpload && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.activate_after_upload.p1')}</p>
              <p>{t('sections.activate_after_upload.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('withdrawingOriginals')}
            aria-expanded={openSections.withdrawingOriginals}
          >
            <h2>{t('sections.withdrawing_originals.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.withdrawingOriginals ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.withdrawingOriginals && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.withdrawing_originals.p1')}</p>
              <p>{t('sections.withdrawing_originals.p2')}</p>
              <p>{t('sections.withdrawing_originals.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('paymentsReturnsRefunds')}
            aria-expanded={openSections.paymentsReturnsRefunds}
          >
            <h2>{t('sections.payments_returns_refunds.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.paymentsReturnsRefunds ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.paymentsReturnsRefunds && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.payments_returns_refunds.p1')}</p>
              <p>{t('sections.payments_returns_refunds.p2')}</p>
              <p>
                {t('sections.payments_returns_refunds.p3_pre')}{' '}
                <Link
                  to="/limited-editions-return-and-refund-policy"
                  state={{ fromPath: '/profile/gallery-help/limited-editions' }}
                >
                  {t('sections.payments_returns_refunds.link_label')}
                </Link>
                {t('sections.payments_returns_refunds.p3_post')}
              </p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('agreementSummary')}
            aria-expanded={openSections.agreementSummary}
          >
            <h2>{t('sections.agreement_summary.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.agreementSummary ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.agreementSummary && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.agreement_summary.intro')}</p>
              <ul>
                <li>{t('sections.agreement_summary.list_1')}</li>
                <li>{t('sections.agreement_summary.list_2')}</li>
                <li>{t('sections.agreement_summary.list_3')}</li>
                <li>{t('sections.agreement_summary.list_4')}</li>
                <li>{t('sections.agreement_summary.list_5')}</li>
                <li>{t('sections.agreement_summary.list_6')}</li>
                <li>{t('sections.agreement_summary.list_7')}</li>
              </ul>
              <p>{t('sections.agreement_summary.p1')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
